import React from "react";
import SEO from "../component/SEO";
import { RiCake3Line } from "react-icons/ri";
import LogoImage from "../images/k-bakery-logo.jpeg";

const About = () => {
  return (
    <div className="relative min-h-screen w-full bg-gradient-to-b from-pink-50 via-[#FFE3E0] to-[#FFD6D1] overflow-hidden p-6 md:p-12 flex flex-col items-center justify-center">
      <SEO 
        title="About Us - K Bakery" 
        description="K Bakery creates edible plot twists that surprise and delight. We specialize in eggless premium quality cakes and desserts."
      />
      {/* Floating Gradient Shapes */}
      <div className="absolute top-10 left-10 w-60 h-60 bg-gradient-to-br from-[#FFB4AB]/50 to-[#E5DEFF]/40 rounded-full float-animation"></div>
      <div
        className="absolute bottom-10 right-10 w-80 h-80 bg-gradient-to-br from-[#E8F4F8]/50 to-[#FFB4AB]/50 rounded-full float-animation"
        style={{ animationDelay: "2s" }}
      ></div>
      <div
        className="absolute top-1/3 right-1/4 w-64 h-64 bg-gradient-to-br from-[#FFD4E3]/60 to-[#E5DEFF]/50 rounded-3xl rotate-12 blur-xl float-animation"
        style={{ animationDelay: "4s" }}
      ></div>
      <div
        className="absolute bottom-1/3 left-1/4 w-52 h-52 bg-gradient-to-br from-[#FFB4AB]/40 to-[#FFD1FF]/30 rounded-2xl blur-lg float-animation"
        style={{ animationDelay: "6s" }}
      ></div>

      {/* Content Container */}
      <div className="relative z-10 max-w-5xl mx-auto bg-white/50 backdrop-blur-lg rounded-3xl shadow-xl p-8 md:p-12 border border-white/40">
        {/* Heading */}
        <h1 className="flex text-4xl md:text-5xl font-serif font-normal mb-6 justify-center items-center gap-3 text-black">
          About Us <RiCake3Line className="text-[#FFB4AB]" />
        </h1>

        {/* Intro */}
        <p className="text-3xl md:text-4xl font-serif font-normal mb-4 text-center text-black">
          Welcome to K Bakery – Your Sweet Escape!
        </p>
        <p className="text-xl md:text-2xl font-serif font-normal mb-6 text-center text-[#1E1E1E]">
          We don’t just bake cakes — we create edible plot twists that surprise and delight.
        </p>

        {/* Story */}
        <p className="text-lg md:text-xl mb-4 leading-relaxed text-[#333333]">
          At K Bakery, every slice tells a story. Classic flavors are reimagined, playful fusions are crafted to surprise, and every creation comes with a promise: eggless doesn’t mean “less” — it means limitless. Our kitchen is where nostalgia meets innovation, where rasmalai shakes hands with red velvet, and even a simple vanilla decides to dress up as a showstopper.
        </p>

        <p className="text-lg md:text-xl mb-4 leading-relaxed text-[#333333]">
          We’re here for your milestones, your midnight cravings, and those last-minute “oops, I forgot to order a cake” emergencies. Beyond birthdays and anniversaries, we turn ordinary days into little celebrations, because life deserves a slice of sweetness every day.
        </p>

        <p className="text-lg md:text-xl mb-6 leading-relaxed text-[#333333]">
          K Bakery is more than desserts. It’s about moments you’ll remember, laughter you’ll share, and happiness you can actually taste. So go on. Cut the slice. Start your story.
        </p>

        {/* CTA */}
        <p className="text-xl font-serif md:text-2xl font-normal text-center mb-8 text-black">
          Visit us today and experience the sweetness of life!
        </p>

        {/* Logo */}
        <div className="flex justify-center">
          <img
            src={LogoImage}
            alt="K Bakery Logo"
            className="w-64 md:w-80 h-64 md:h-80 object-contain rounded-full shadow-lg border-4 border-[#FFB4AB]/70 backdrop-blur-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
